import gql from 'graphql-tag'

const createCliente = gql`
  mutation createClienteWithTags($cliente: CreateCliente!, $zone: String, $interessi: String) {
    createClienteWithTags(cliente: $cliente, zone: $zone, interessi: $interessi) {
      id
      agenteId
      nome
      comune
      email
      email2
      telefono
      telefono2
      dataNascita
      lingua
      tipoPnl
      famiglia
      percheCompra
      quandoInteressato
      quantoInteressato
      voto
      dataCreazione
      daRicontattare
      dataUltimoContatto
      dataUltimaRichiesta
      zone {
        nome
      }
      interessi {
        nome
      }
    }
  }
`

export default createCliente


// WEBPACK FOOTER //
// ./src/graphql/mutations/createCliente.js